import { combineReducers } from 'redux'

import * as api from '../api'
import * as auth from '../auth'
import * as entities from '../entities'
import * as confirmation from '../confirmation'
import * as header from '../header'
import * as map from '../map'
import * as wordpress from '../wordpress'
import * as search from '../search'
import * as creditCards from '../credit-cards'
import * as dashboardTransactions from '../dashboard-transactions'
import * as dashboardSubscriptions from '../dashboard-subscriptions'
import * as carParks from '../car-parks'
import * as booking from '../booking'
import * as extending from '../extending'
import * as dashboard from '../dashboard'
import * as onDemandParking from '../dashboard-on-demand-parking'
import * as loginAndSignup from '../login-and-signup'
import * as settings from '../settings'
import * as location from '../browser-location'
import * as news from '../news'
import * as onStreet from '../on-street'
import * as purchaseFlowCanada from 'subscription-flow/canada'
import * as cookies from '../cookies'
import * as nps from '../nps-view'
import searchDateTime from '../search-date-time'
import * as waitingList from 'subscription-flow/waitlist/reducer'
import * as scanticket from '../scanticket'
import * as googlePay from '../credit-cards/google-pay'

export default combineReducers({
    creditCards: creditCards.reducer,
    confirmation: confirmation.reducer,
    pending: api.reducer,
    header: header.reducer,
    locationSearch: search.reducer.locationReducer,
    eventsSearch: search.reducer.eventsReducer,
    loginAndSignup: loginAndSignup.reducer,
    dashboardSubscriptions: dashboardSubscriptions.reducer,
    subscriptionPurchase: purchaseFlowCanada.reducer,
    cookies: cookies.reducer,
    nps: nps.reducer,
    waitingList: waitingList.reducer,
    scanticket: scanticket.reducer,
    ...entities.reducers,
    ...auth.reducers,
    ...location.reducers,
    ...searchDateTime.reducers,
    ...wordpress.reducers,
    ...map.reducers,
    ...dashboardTransactions.reducers,
    ...carParks.reducers,
    ...booking.reducers,
    ...extending.reducers,
    ...dashboard.reducers,
    ...onDemandParking.reducers,
    ...settings.reducers,
    ...news.reducers,
    ...onStreet.reducers,
    ...googlePay.reducers,
})
